import script from "./DealerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DealerComponent.vue?vue&type=script&setup=true&lang=js"

import "./DealerComponent.vue?vue&type=style&index=0&id=4a0b9572&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a0b9572"]])

export default __exports__